import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IScanningPrefix, ScanningPrefixService } from '@shared/services/scanning-prefix.service';

@Component({
	selector: 'app-delete-scanning-prefix',
	templateUrl: './delete-scanning-prefix.component.html',
	styleUrl: './delete-scanning-prefix.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DeleteScanningPrefixComponent {
	@Output() deleted: EventEmitter<any> = new EventEmitter();
	httpError: string = '';
	loading: boolean | null;

	constructor(
		@Inject(MAT_DIALOG_DATA) public scanningPrefix: IScanningPrefix,
		public dialogRef: MatDialogRef<DeleteScanningPrefixComponent>,
		private service: ScanningPrefixService,
	) {}

	onCancel = () => this.dialogRef.close();

	async onDelete() {
		if (this.loading) return;
		this.loading = true;
		this.httpError = '';

		this.service.delete(this.scanningPrefix.id).subscribe({
			next: () => {
				this.deleted.emit();
				this.dialogRef.close();
			},
			error: (errorResponse) => {
				this.httpError = `${errorResponse.status}`;
				this.loading = false;
			},
		});
	}
}
